module.exports = {
  REACT_APP_API_URL: `https://api.gxgroup.eu/api`,
};
// http://localhost:5002/api
// http://gx-dev.ap-south-1.elasticbeanstalk.com/api
// http://gx-dev.ap-south-1.elasticbeanstalk.com/api'
